export const translations = {
  hu: {
    topbar: {
      enabled: true,
      message: "",
      schedule: {
        mon: "11:00-22:00",
        tue: "11:00-22:00",
        wed: "11:00-22:00",
        thu: "11:00-22:00",
        fri: "11:00-24:00",
        sat: "12:00-24:00",
        sun: "",
      },
      labels: { open: "NYITVA", closed: "ZÁRVA", today: "MA" },
    },
    nav: {
      about: "Rólunk",
      menu: "Heti Menü",
      menus: "Étlap & Itallap",
      gallery: "Galéria",
      reviews: "Vélemények",
      contact: "Kapcsolat",
    },
    hero: {
      eyebrow: "GYŐR · PÁLFFY U. 2",
      line1: "ÍZEK.",
      line2: "ITALOK.",
      line3: "TALÁLKOZÁSOK.",
      lead:
        "A Faceroom több, mint egy bar és bisztró — egy hely, ahol a napi menü kézzel készül, a koktélokat pedig szenvedéllyel kavarjuk.",
      cta: "HETI MENÜ",
    },
    marquee: "FACE ROOM · ÉTTEREM ÉS DRINKBÁR · ÉLMÉNY A SZEMNEK · A SZÁJNAK · A SZÍVNEK ·",
    about: {
      eyebrow: "RÓLUNK",
      headline: "SZEMNEK, SZÁJNAK, SZÍVNEK.",
      p1: "Régóta vágyunk egy olyan helyre, ahol egy igazán varázslatos estét, vagy könnyed délutáni pillanatokat tölthetünk el. Egy olyan étteremre, ahol harmóniában van a trendi belsőépítészeti megjelenés, a modern konyha ízvilágával és a kiszolgálás lendületével.",
      p2: "Győr belvárosának szívében mindez most megvalósul a Face Room Étteremben, amely otthont ad egy délelőtti üzleti megbeszélésnek, egy kellemes családi ebédnek éppúgy, mint egy színház utáni vacsorának vagy egy szombat esti buli előtti baráti beszélgetésnek.",
      p3: "Konyhánkban az európai fúziós konyhaművészet remekeit kínáljuk vendégeinknek, különböző konyhakultúrák ötvözéséből.",
      sign: "— Face Room. Élmény a szemnek, a szájnak, a szívnek.",
    },
    weekly: {
      eyebrow: "AMIT MA FŐZÜNK",
      headline: "HETI MENÜ",
      sub: "Naponta változó, kézzel készülő ételek. Levesek 800 Ft · Főételek 2600 Ft · Extra menü 4500 Ft",
      extraLabel: "EXTRA MENÜ — 4500 Ft",
      extraDish: "Húsleves + Stroganoff bélszín rizzsel",
      soup: "Leves",
      main: "Főétel",
      days: [
        {
          date: "Hétfő",
          soups: ["Húsleves májgombóccal", "Francia hagymaleves"],
          mains: [
            "Füstölt sajttal, brokkolival töltött csirkemell hasábburgonyával",
            "Szűzérmék mustáros barnamártással, tócsnival",
          ],
        },
        {
          date: "Kedd",
          soups: ["Húsleves májgombóccal", "Burgonyaleves"],
          mains: [
            "Füstölt sajttal, brokkolival töltött csirkemell hasábburgonyával",
            "Grillezett csirkemell barackkal, sajttal sütve, rizzsel",
          ],
        },
        {
          date: "Szerda",
          soups: ["Húsleves májgombóccal", "Zöldborsóleves"],
          mains: [
            "Füstölt sajttal, brokkolival töltött csirkemell hasábburgonyával",
            "Burgonyafőzelék fasírozottal",
          ],
        },
        {
          date: "Csütörtök",
          soups: ["Húsleves májgombóccal", "Gombaleves"],
          mains: [
            "Füstölt sajttal, brokkolival töltött csirkemell hasábburgonyával",
            "Vadas szelet zsemlegombóccal",
          ],
        },
        {
          date: "Péntek",
          soups: ["Húsleves májgombóccal", "Csülkös bableves"],
          mains: [
            "Füstölt sajttal, brokkolival töltött csirkemell hasábburgonyával",
            "Rántott zöldségek, rizzsel, tartármártással",
          ],
        },
      ],
    },
    menus: {
      eyebrow: "AZ ÉTTEREM KÍNÁLATA",
      headline: "ÉTLAP & ITALLAP",
      food: {
        title: "ÉTLAP",
        sub: "Hideg-meleg előételek és levesek, szárnyasok, marha, sertés és halételek, tészták, vadételek, desszertek.",
        cta: "ÉTLAP MEGTEKINTÉSE",
      },
      drinks: {
        title: "ITALLAP",
        sub: "Meleg italok, ásványvizek és üdítők, sör, bor és röviditalok, alkoholos és alkoholmentes koktélok.",
        cta: "ITALLAP MEGTEKINTÉSE",
      },
    },
    gallery: {
      eyebrow: "PILLANATOK",
      headline: "GALÉRIA",
      sub: "Belső tér, kézzel kevert koktélok, gondosan tálalt ételek.",
    },
    reviews: {
      eyebrow: "AMIT VENDÉGEINK MONDANAK",
      headline: "VÉLEMÉNYEK",
      items: [
        {
          name: "K. Anna",
          city: "Győr",
          text: "A koktélok mesterművek, a hangulat pedig pont olyan, amilyenre vágytunk. A személyzet kedves és figyelmes — minden látogatás új élmény.",
        },
        {
          name: "B. Péter",
          city: "Budapest",
          text: "Üzleti ebéd, és kétségkívül a legjobb választás volt Győrben. Friss alapanyagok, igényes tálalás. Visszajárunk.",
        },
        {
          name: "Sz. Réka",
          city: "Mosonmagyaróvár",
          text: "Szombat este teli ház, mégis minden gördülékeny volt. A bélszín tökéletes, az atmoszféra varázslatos.",
        },
        {
          name: "T. Márk",
          city: "Sopron",
          text: "A heti menü olcsó és valóban házias — kézzel főzött, minőségi ízek. Ritka kincs a városban.",
        },
        {
          name: "H. Eszter",
          city: "Győr",
          text: "Színház után tértünk be, és nem bántuk meg. A bartender egy mestermű narancsos koktélt kevert — azóta is ezt iszom.",
        },
        {
          name: "N. Gábor",
          city: "Tatabánya",
          text: "Modern belsőépítészet, profi konyha, gyors kiszolgálás. Ár-érték arányban verhetetlen.",
        },
      ],
    },
    contact: {
      eyebrow: "KAPCSOLAT",
      headline: "GYERE BE, ÜLJ LE, KÓSTOLJ.",
      address: "Cím",
      addressValue: "Győr, Pálffy u. 2.",
      phone: "Telefon",
      phoneValue: "+36 96 823 105",
      email: "Email",
      emailValue: "info@faceroom.hu",
      hours: "Nyitvatartás",
      hoursTable: [
        { d: "Hétfő – Csütörtök", t: "11:00 – 22:00" },
        { d: "Péntek", t: "11:00 – 24:00" },
        { d: "Szombat", t: "12:00 – 24:00" },
        { d: "Vasárnap", t: "Zárva" },
      ],
      facebook: "Facebook",
      gps: "GPS",
      gpsValue: "47°41'16.0\"É · 17°38'11.0\"K",
    },
    footer: {
      tagline: "Étterem és drinkbár · Győr",
      rights: "Minden jog fenntartva.",
    },
  },
  en: {
    topbar: {
      enabled: true,
      message: "",
      schedule: {
        mon: "11:00-22:00",
        tue: "11:00-22:00",
        wed: "11:00-22:00",
        thu: "11:00-22:00",
        fri: "11:00-24:00",
        sat: "12:00-24:00",
        sun: "",
      },
      labels: { open: "OPEN", closed: "CLOSED", today: "TODAY" },
    },
    nav: {
      about: "About",
      menu: "Daily Menu",
      menus: "Food & Drinks",
      gallery: "Gallery",
      reviews: "Reviews",
      contact: "Contact",
    },
    hero: {
      eyebrow: "GYŐR · PÁLFFY U. 2",
      line1: "FLAVORS.",
      line2: "DRINKS.",
      line3: "MOMENTS.",
      lead:
        "Faceroom is more than a bar and bistro — a place where the daily menu is made by hand and the cocktails are stirred with passion.",
      cta: "DAILY MENU",
    },
    marquee: "FACE ROOM · RESTAURANT & DRINKBAR · A FEAST FOR THE EYES · THE PALATE · THE HEART ·",
    about: {
      eyebrow: "ABOUT US",
      headline: "FOR THE EYES, PALATE, HEART.",
      p1: "We always longed for a place to spend a truly magical evening, or easy afternoon moments. A restaurant where trendy interior design lives in harmony with modern flavors and attentive service.",
      p2: "In the heart of downtown Győr, this is now reality at Face Room — at home with a morning business meeting, a warm family lunch, an after-theatre dinner or pre-party drinks with friends.",
      p3: "Our kitchen serves European fusion creations, blending culinary cultures with a few signature Hungarian classics.",
      sign: "— Face Room. A feast for the eyes, the palate, the heart.",
    },
    weekly: {
      eyebrow: "WHAT WE COOK TODAY",
      headline: "DAILY MENU",
      sub: "Hand-crafted dishes changing every day. Soups 800 HUF · Mains 2600 HUF · Extra menu 4500 HUF",
      extraLabel: "EXTRA MENU — 4500 HUF",
      extraDish: "Beef broth + Beef Stroganoff with rice",
      soup: "Soup",
      main: "Main",
      days: [
        {
          date: "Monday",
          soups: ["Beef broth with liver dumplings", "French onion soup"],
          mains: [
            "Chicken breast stuffed with smoked cheese & broccoli, fries",
            "Pork medallions in mustard sauce, potato pancake",
          ],
        },
        {
          date: "Tuesday",
          soups: ["Beef broth with liver dumplings", "Potato soup"],
          mains: [
            "Chicken breast stuffed with smoked cheese & broccoli, fries",
            "Grilled chicken breast with peach, baked with cheese, rice",
          ],
        },
        {
          date: "Wednesday",
          soups: ["Beef broth with liver dumplings", "Green pea soup"],
          mains: [
            "Chicken breast stuffed with smoked cheese & broccoli, fries",
            "Potato stew with meatballs",
          ],
        },
        {
          date: "Thursday",
          soups: ["Beef broth with liver dumplings", "Mushroom soup"],
          mains: [
            "Chicken breast stuffed with smoked cheese & broccoli, fries",
            "Hungarian 'vadas' beef with bread dumplings",
          ],
        },
        {
          date: "Friday",
          soups: ["Beef broth with liver dumplings", "Bean soup with ham hock"],
          mains: [
            "Chicken breast stuffed with smoked cheese & broccoli, fries",
            "Breaded vegetables, rice, tartar sauce",
          ],
        },
      ],
    },
    menus: {
      eyebrow: "WHAT'S ON OFFER",
      headline: "FOOD & DRINKS",
      food: {
        title: "FOOD MENU",
        sub: "Cold & hot starters and soups, poultry, beef, pork and fish, pastas, game dishes, desserts.",
        cta: "VIEW FOOD MENU",
      },
      drinks: {
        title: "DRINK MENU",
        sub: "Hot drinks, mineral waters, soft drinks, beer, wine, spirits, alcoholic and non-alcoholic cocktails.",
        cta: "VIEW DRINK MENU",
      },
    },
    gallery: {
      eyebrow: "MOMENTS",
      headline: "GALLERY",
      sub: "Interior, hand-mixed cocktails, carefully plated food.",
    },
    reviews: {
      eyebrow: "WHAT GUESTS SAY",
      headline: "REVIEWS",
      items: [
        {
          name: "A. K.",
          city: "Győr",
          text: "The cocktails are masterpieces and the vibe is exactly what we hoped for. Staff is warm and attentive — every visit feels new.",
        },
        {
          name: "P. B.",
          city: "Budapest",
          text: "Business lunch and the best choice in Győr — fresh ingredients, refined plating. We keep coming back.",
        },
        {
          name: "R. Sz.",
          city: "Mosonmagyaróvár",
          text: "Full house on Saturday night and yet everything ran smoothly. The beef was perfect, the atmosphere magical.",
        },
        {
          name: "M. T.",
          city: "Sopron",
          text: "The weekly menu is honestly priced and truly home-cooked — rare quality in town.",
        },
        {
          name: "E. H.",
          city: "Győr",
          text: "Dropped in after the theatre and didn't regret it. The bartender mixed a stunning orange cocktail — my drink of choice ever since.",
        },
        {
          name: "G. N.",
          city: "Tatabánya",
          text: "Modern interior, pro kitchen, quick service. Unbeatable value for money.",
        },
      ],
    },
    contact: {
      eyebrow: "CONTACT",
      headline: "COME IN, SIT DOWN, TASTE.",
      address: "Address",
      addressValue: "Győr, Pálffy u. 2., Hungary",
      phone: "Phone",
      phoneValue: "+36 96 823 105",
      email: "Email",
      emailValue: "info@faceroom.hu",
      hours: "Opening Hours",
      hoursTable: [
        { d: "Monday – Thursday", t: "11:00 – 22:00" },
        { d: "Friday", t: "11:00 – 24:00" },
        { d: "Saturday", t: "12:00 – 24:00" },
        { d: "Sunday", t: "Closed" },
      ],
      facebook: "Facebook",
      gps: "GPS",
      gpsValue: "47°41'16.0\"N · 17°38'11.0\"E",
    },
    footer: {
      tagline: "Restaurant & drinkbar · Győr",
      rights: "All rights reserved.",
    },
  },
};
